import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AccessiService {

  private apiUrl = environment.apiUrl + '/accessi';

  constructor(
    private http: HttpClient
  ) { }

  create(request: any): Observable<any> {

    return this.http.post<any>(
      this.apiUrl,
      request
    );
  }

  getById(id: number): Observable<any> {

    return this.http.get<any>(
      `${this.apiUrl}/${id}`
    );
  }

  getByPatient(idPaziente: number): Observable<any[]> {

    return this.http.get<any[]>(
      `${this.apiUrl}/by-patient/${idPaziente}`
    );
  }

  getLatest(): Observable<any[]> {

    return this.http.get<any[]>(
      `${this.apiUrl}/latest`
    );
  }

  update(
    id: number,
    request: any
  ): Observable<any> {

    return this.http.put<any>(
      `${this.apiUrl}/${id}`,
      request
    );
  }

  updateContatti(
    idAccesso: number,
    request: any
  ) {

    return this.http.put<any>(
      `${this.apiUrl}/contatti/${idAccesso}`,
      request
    );
  }

  getMmgLetterPdf(idAccesso: number): Observable<Blob> {

    return this.http.get(
      `${this.apiUrl}/${idAccesso}/mmg-letter`,
      {
        responseType: 'blob'
      }
    );
  }

  delete(id: number): Observable<any> {

    return this.http.delete<any>(
      `${this.apiUrl}/${id}`
    );
  }
}